import React, { useEffect } from "react";
import Select from "react-select";
import { useFormikContext } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { reqToGetStaffList } from "../../redux/slices.js/staff/staffSlice";

const supportOwner = [
  { value: "john-smith", label: "John Smith" },
  { value: "sarah-johnson", label: "Sarah Johnson" },
  { value: "wilson-james", label: "Wilson James" },
];

const AssignOnboarding = [
  { value: "john-smith", label: "John Smith" },
  { value: "sarah-johnson", label: "Sarah Johnson" },
  { value: "wilson-james", label: "Wilson James" },
];

const toggles = [
  { id: "enableSSO", label: "Enable Single Sign-On (SSO)" },
  { id: "enableAPI", label: "Enable API Access" },
  { id: "enableBranding", label: "Enable custom branding" },
];

const Configuration = () => {
  const dispatch = useDispatch();
  const { values, errors, touched, handleChange, setFieldValue, handleBlur } =
    useFormikContext();
  const staffList = useSelector((state) => state.staff.staffList);

  const supportOwnerOptions = staffList
    .filter((staff) => staff.status === "active")
    .map((staff) => ({
      value: staff.id,
      label: staff.name,
    }));

  const onboardingOptions = staffList
    .filter((staff) => staff.status === "active")
    .map((staff) => ({
      value: staff.id,
      label: staff.name,
    }));

  useEffect(() => {
    dispatch(
      reqToGetStaffList({
        data: {},
        onSuccess: (res) => {},
        onFailure: (err) => {
          console.error("Failed to fetch staff list:", err);
        },
      })
    );
  }, [dispatch]);

  const handleToggle = (id) => {
    setFieldValue(id, !values[id]);
  };

  return (
    <div className="space-y-6">
      <section className="space-y-6 flex-1">
        <div className="grid gap-6 md:grid-cols-1">
          <div className="form-group">
            <label>
              Assign support owner <span>*</span>
            </label>
            <Select
              name="supportOwner"
              options={supportOwnerOptions}
              placeholder="Select Assign support owner"
              isClearable={false}
              isSearchable={false}
              value={supportOwnerOptions.find(
                (option) => option.value === values.supportOwner
              )}
              onChange={(option) => setFieldValue("supportOwner", option.value)}
              onBlur={handleBlur}
              className={
                errors.supportOwner && touched.supportOwner
                  ? "error-select"
                  : ""
              }
            />
            {errors.supportOwner && touched.supportOwner && (
              <div className="error-message">{errors.supportOwner}</div>
            )}
          </div>

          <div className="form-group">
            <label>
              Assign Onboarding specialist <span>*</span>
            </label>
            <Select
              name="onboardingSpecialist"
              options={onboardingOptions}
              placeholder="Select Assign Onboarding specialist"
              isClearable={false}
              isSearchable={false}
              value={onboardingOptions.find(
                (option) => option.value === values.onboardingSpecialist
              )}
              onChange={(option) =>
                setFieldValue("onboardingSpecialist", option.value)
              }
              onBlur={handleBlur}
              className={
                errors.onboardingSpecialist && touched.onboardingSpecialist
                  ? "error-select"
                  : ""
              }
            />
            {errors.onboardingSpecialist && touched.onboardingSpecialist && (
              <div className="error-message">{errors.onboardingSpecialist}</div>
            )}
          </div>

          <div className="space-y-5">
            {toggles.map((toggle) => (
              <div
                key={toggle.id}
                className="flex items-center justify-start gap-4"
              >
                <button
                  type="button"
                  role="switch"
                  aria-checked={values[toggle.id]}
                  onClick={() => handleToggle(toggle.id)}
                  className={`relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${
                    values[toggle.id] ? "bg-[#4285F4]" : "bg-[#E5E7EB]"
                  }`}
                >
                  <span
                    aria-hidden="true"
                    className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                      values[toggle.id] ? "translate-x-[10px]" : "translate-x-0"
                    }`}
                  />
                </button>
                <span className="text-black text-span">{toggle.label}</span>
              </div>
            ))}
          </div>

          <div className="form-group">
            <label>
              Data retention period (days) <span>*</span>
            </label>
            <input
              type="number"
              name="dataRetentionPeriod"
              placeholder=""
              value={values.dataRetentionPeriod}
              onChange={handleChange}
              onBlur={handleBlur}
              className={
                errors.dataRetentionPeriod && touched.dataRetentionPeriod
                  ? "error"
                  : ""
              }
            />
            {errors.dataRetentionPeriod && touched.dataRetentionPeriod && (
              <div className="error-message">{errors.dataRetentionPeriod}</div>
            )}
          </div>

          <div className="form-group">
            <label>Internal Notes</label>
            <textarea
              name="internalNotes"
              rows={5}
              placeholder="Enter internal notes"
              value={values.internalNotes}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Configuration;
